/**
 * 数量加减器
 */
import React, { useEffect, useRef, useState } from "react";
import "./index.less";
import DFImage from "../DFImage";
import { add_df_listen_scroll } from "@/utils";
const topIcon = require("./imgs/topIcon.png");

/** 单行显示组件 */
const TopPart = () => {
  const [showIcon, setShowIcon] = useState<boolean>(false);
  // 当前容器
  const currentDom = useRef<any>();
  useEffect(() => {
    add_df_listen_scroll(lazyLoad, null);
  }, [showIcon]);

  const lazyLoad = (ele: any) => {
    currentDom.current = ele;
    // console.log("ele.scrollTop", ele.scrollTop, ele.offsetHeight / 1.5);
    if (!showIcon && ele.scrollTop > ele.offsetHeight / 1.5) {
      setShowIcon(true);
    } else if (showIcon && ele.scrollTop < ele.offsetHeight / 1.5) {
      setShowIcon(false);
    }
  };

  return (
    <>
      {showIcon && (
        <div className={`top-part`}>
          <img
            src={topIcon}
            onClick={() => {
              if (currentDom.current) {
                currentDom.current.scrollTo(0, 0);
                setShowIcon(false);
              }
            }}
          />
        </div>
      )}
    </>
  );
};

export default TopPart;
